import { motion } from "framer-motion";
import { Link } from "wouter";
import { Logo } from "@/components/Logo";
import { ThemeToggle } from "@/components/ThemeToggle";

export default function ShippingAndRefunds() {
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 bg-background/95 backdrop-blur border-b border-border">
        <div className="container mx-auto px-4 py-3 flex items-center justify-between gap-4">
          <Link href="/">
            <Logo size="md" />
          </Link>
          <ThemeToggle />
        </div>
      </header>
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="prose dark:prose-invert max-w-none"
        >
          <h1>Shipping, Refunds & Cancellation</h1>
          <p className="text-muted-foreground italic">Last Updated: January 12, 2026</p>
          
          <section className="mt-8">
            <h2>1. Digital Service</h2>
            <p>DailyHisaab is a digital software-as-a-service (SaaS) product. No physical shipping is involved.</p>
          </section>

          <section>
            <h2>2. Refund Policy</h2>
            <p>Since DailyHisaab provides a digital service and offers a free tier, all payments made for Pro features or credits are generally non-refundable. However, we may consider refunds on a case-by-case basis for technical errors.</p>
          </section>

          <section>
            <h2>3. Cancellation</h2>
            <p>You may cancel your subscription at any time through your account settings. Upon cancellation, you will retain access to Pro features until the end of your current billing cycle.</p>
          </section>

          <section>
            <h2>4. Contact</h2>
            <p>For billing issues, contact billing@dailyhisaab.com.</p>
          </section>
        </motion.div>
      </main>

      <footer className="border-t border-border py-8 mb-safe">
        <div className="container mx-auto px-4">
          <div className="flex flex-col items-center gap-6 text-center">
            <Link href="/">
              <Logo size="sm" />
            </Link>

            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
              <Link
                href="/privacy"
                className="hover:text-primary transition-colors whitespace-nowrap"
              >
                Privacy Policy
              </Link>
              <Link
                href="/terms"
                className="hover:text-primary transition-colors whitespace-nowrap"
              >
                Terms of Service
              </Link>
              <Link
                href="/data-deletion"
                className="hover:text-primary transition-colors whitespace-nowrap"
              >
                Data Deletion Policy
              </Link>
            </div>

            <div className="space-y-1">
              <p className="text-sm text-muted-foreground">
                Made with ❤️ in Bengal by{" "}
                <a
                  href="https://asldigitalsolutions.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary font-semibold hover:underline"
                >
                  ASL Digital Solutions
                </a>
              </p>
              <p className="text-sm text-muted-foreground">
                ©2026 DailyHisaab.🇮🇳 All Rights Reserved
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
